import iconThriveLetter from "@assets/thrive_images/icon-thrive-letter.png";
import {
  BT_NEWSLETTERS,
  NEWSLETTER_TYPE,
} from "@components/Newsletter/types/Newsletter";
import NewsletterForm from "@features/newsletter/components/NewsletterForm";
import { cn } from "@util/helpers";

import ThriveSuccessMessage from "./ThriveSuccessMessage";

/**
 * Component to render Thrive newsletter signup on thrive page.
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-88182&m=dev
 *
 * */
const ThriveNewsletter = (): React.ReactElement => {
  const newsletters = BT_NEWSLETTERS.filter(
    ({ type }) => type === NEWSLETTER_TYPE.THRIVE
  );

  return (
    <div
      data-testid="thrive-newsletter"
      className="mb-6 w-full rounded-lg bg-red-210 p-4"
    >
      <div className="flex flex-row items-start gap-3">
        <p className="mb-4 font-inter text-base font-medium text-white">
          Join over 80,000 thrivers for no-BS takes on what really matters to
          young adults. Straight to your inbox, every Friday.
        </p>

        <img
          src={iconThriveLetter}
          alt="thrive-letter"
          width={50}
          height={50}
        />
      </div>

      <NewsletterForm
        newsletters={newsletters}
        buttonClassName={cn(
          "rounded-full bg-red-210 px-4 py-3 text-white font-inter border-none hover:border-none hover:bg-red-230"
        )}
        buttonLoadingClass="bg-red-230"
        inputClassName="text-gray-850 placeholder:text-red-210 md:w-full font-inter text-xs"
        placeholder="Email address"
        formClassName="px-3 pl-5 py-2 rounded-full"
        errorClassName="text-white pl-4"
        isBordered={false}
        successMessage={<ThriveSuccessMessage />}
        formFocusClassName="focus-within:border-2 focus-within:border-green-100"
      />
    </div>
  );
};

export default ThriveNewsletter;
